import React from "react";

import { Handle, Position } from "@xyflow/react";

import Grid from "@mui/material/Unstable_Grid2";
import { Box, Card, Chip, Stack } from "@mui/material";

/**
 * GroupNode component
 * @description Component to render a group node in the React Flow diagram.
 * @param {NodeProps<ReactflowNodeData>} props - Component props
 * @returns {JSX.Element} The rendered component
 */
export function GroupedNode(props: any) {
  const { data } = props;
  const isSuppressed = data.is_suppressed === true;
  const nodeType = data.type;

  // Style basé sur is_suppressed (même logique que BaseNode)
  const getNodeStyle = () => {
    if (nodeType === "commune") {
      return { bg: "#9e9e9e", text: "#fff" };
    }
    if (nodeType === "cadastre") {
      return isSuppressed
        ? { bg: "#e8f5e9", text: "#2e7d32" }
        : { bg: "#4caf50", text: "#fff" };
    }
    if (nodeType === "volume") {
      return isSuppressed
        ? { bg: "#ffe0b2", text: "#e65100" }
        : { bg: "#f57c00", text: "#fff" };
    }
    if (nodeType === "lot") {
      return isSuppressed
        ? { bg: "#bbdefb", text: "#0d47a1" }
        : { bg: "#1976d2", text: "#fff" };
    }
    return { bg: "#9e9e9e", text: "#fff" };
  };

  const nodeStyle = getNodeStyle();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
      <Handle type="target" position={Position.Top} />
      {/* Node content */}
      <Card
        elevation={0}
        style={{ maxHeight: "192px", overflowY: "auto", padding: "8px", background: "transparent", border: "none" }}
      >
        {Array.isArray(data.value) && data.value.length > 3 ? (
          <Grid container spacing={0.5}>
            {data.value.map((node: any, index: number) => {
              return (
                <Grid key={`node-group-item-${index}-${node}`} xs={6}>
                  <Chip
                    clickable
                    size="small"
                    label={node}
                    sx={{
                      fontSize: "10px",
                      width: 1,
                      backgroundColor: nodeStyle.bg,
                      color: nodeStyle.text,
                      border: "none",
                      '& .MuiChip-label': { color: nodeStyle.text },
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <Stack
            direction="row"
            justifyContent={data.value?.length === 1 ? "center" : "space-between"}
            alignItems="center"
            spacing={0.5}
          >
            {Array.isArray(data.value) &&
              data.value.map((node: any, index: number) => {
                return (
                  <Chip
                    clickable
                    key={`node-group-item-${index}-${node}`}
                    size="small"
                    label={node}
                    sx={{
                      fontSize: "10px",
                      width: 1,
                      backgroundColor: nodeStyle.bg,
                      color: nodeStyle.text,
                      border: "none",
                      '& .MuiChip-label': { color: nodeStyle.text },
                    }}
                  />
                );
              })}
          </Stack>
        )}
      </Card>
      <Handle type="source" position={Position.Bottom} />
    </Box>
  );
}

GroupedNode.displayName = "GroupNode";
